var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCategoryMobile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 8H14.25C15.75 8 16.5 7.25 16.5 5.75V4.25C16.5 2.75 15.75 2 14.25 2H12.75C11.25 2 10.5 2.75 10.5 4.25V5.75C10.5 7.25 11.25 8 12.75 8Z",
    stroke: "#1B3F7A",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 17H5.25C6.75 17 7.5 16.25 7.5 14.75V13.25C7.5 11.75 6.75 11 5.25 11H3.75C2.25 11 1.5 11.75 1.5 13.25V14.75C1.5 16.25 2.25 17 3.75 17Z",
    stroke: "#1B3F7A",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.34,
    d: "M4.5 8C6.15685 8 7.5 6.65685 7.5 5C7.5 3.34315 6.15685 2 4.5 2C2.84315 2 1.5 3.34315 1.5 5C1.5 6.65685 2.84315 8 4.5 8Z",
    stroke: "#1B3F7A",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.34,
    d: "M13.5 17C15.1569 17 16.5 15.6569 16.5 14C16.5 12.3431 15.1569 11 13.5 11C11.8431 11 10.5 12.3431 10.5 14C10.5 15.6569 11.8431 17 13.5 17Z",
    stroke: "#1B3F7A",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategoryMobile);
export default __webpack_public_path__ + "static/media/category-mobile.d376496cd935c7e230647dcc6958364a.svg";
export { ForwardRef as ReactComponent };